import { render, staticRenderFns } from "./LandingArticles.vue?vue&type=template&id=5764f8eb&scoped=true&"
import script from "./LandingArticles.vue?vue&type=script&lang=js&"
export * from "./LandingArticles.vue?vue&type=script&lang=js&"
import style0 from "./LandingArticles.vue?vue&type=style&index=0&id=5764f8eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5764f8eb",
  null
  
)

/* custom blocks */
import block0 from "./LandingArticles.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./LandingArticles.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
